import { useCallback } from 'react';
import dayjs from 'dayjs';
import { Video } from '@bpm-web-app/download-api-sdk';
import Card from '../card';
import styles from './video-card.module.css';

interface VideoCardProps {
    video: Video;
}

export function VideoCard({ video }: VideoCardProps) {
    const getSubtitleMarkup = useCallback(() => {
        return <div className={styles['video-card__subtitle']}>{`${video.category?.name} / ${dayjs(video.created_at).format('MMMM D, YYYY')}`}</div>;
    }, [video]);

    return (
        <Card
            cardSize="wide"
            imageUrl={video?.thumbnail_url || ''}
            id={video.id}
            title={video.title}
            description={getSubtitleMarkup()}
            isDescriptionSingleLine
            link={`/academy/${video.slug}`}
            isPlayable={false}
        />
    );
}
